import React, { useContext } from "react"
import { Context } from "../store/UserProvider"
import Logo from "../../images/montessoriLogo.svg"
import SignInLogo from "../../images/login.svg"
import * as Style from "./Header.module.scss"
import Button from "../UI/button/Button"
import { navigate } from "gatsby"

const Header = ({ signin, registration, pageMode }) => {
  const ctx = useContext(Context)

  const navbarHandler = event => {
    navigate("/sign_in")
    ctx.changeForm(event.target.dataset.type)
    ctx.setResetPassSend(false)
  }

  return (
    <div
      className={`${Style.header} ${
        pageMode === "sign_in" ? Style.headerLogoCenter : ""
      }`}
    >
      <Logo className={Style.logo} />
      {pageMode === "index" && (
        <div className={Style.buttonHeaderWrapper}>
          <Button
            buttonHandler={navbarHandler}
            dataset="signin"
            style={Style.buttonTwo}
          >
            <div className={Style.changeContentIcon}>
              <SignInLogo />
            </div>
            <p className={Style.changeContentText}>{signin}</p>
          </Button>
          <Button
            buttonHandler={navbarHandler}
            dataset="registration"
            style={Style.buttonOne}
          >
            {registration}
          </Button>
        </div>
      )}
    </div>
  )
}

export default Header
